import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    toggle() {
        document.body.classList.toggle('show-menu');
    }

    close() {
        document.body.classList.remove('show-menu');
    }
}
